/**
 * 
 * @file Footer component
 * @author Box
 */

import * as React from 'react';


var Footer = function Footer(_ref) {
    var children = _ref.children;
    return React.createElement(
        'footer',
        { className: 'bce-footer' },
        children
    );
};

export default Footer;